export default "__VITE_ASSET__BBJNqlz3__"